<template>
    <v-app>
    <div class="md-layout">
        <div class="md-layout-item md-size-100" style="padding-bottom: 20px">
            <md-toolbar class="md-success" md-elevation="1">
                <div class="md-toolbar-row">
                    <div class="md-toolbar-section-start">
                        <h3 class="md-title" style="padding-left: 20px; padding-bottom: 10px">
                            设备库
                        </h3>
                        <md-button class="md-success" @click="handleResourceNew">
                            <md-icon>person_add</md-icon> 新建设备模型
                        </md-button>
                    </div>
                    <div class="md-toolbar-section-end">
                        <drop-down direction="down">
                            <md-button slot="title" class="md-button md-success dropdown-toggle" data-toggle="dropdown">
                                专业分类
                            </md-button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li v-for="item in majorListData" :key="item.index" @click="categorySelected('profession', item.index)">
                                    <a href="#">{{ item.name }}</a>
                                </li>
                            </ul>
                        </drop-down>
                        <drop-down direction="down">
                            <md-button slot="title" class="md-button md-success dropdown-toggle" data-toggle="dropdown">
                                行业分类
                            </md-button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li v-for="item in industryListData" :key="item.index" @click="categorySelected('industry', item.index)">
                                    <a href="#">{{ item.name }}</a>
                                </li>
                            </ul>
                        </drop-down>
                        <md-button class="md-success" @click="clearFilter">
                            清除筛选 <md-icon>filter_list_off</md-icon>
                        </md-button>
                    </div>
                </div>
            </md-toolbar>
            <md-toolbar style="
            background: #f8f8f8 !important;
            border-radius: 0px;
            max-height: 15px;
            box-shadow: none;
            margin: 0px;
            padding: 0px;
            z-index: auto;
          " md-elevation="0">
                <div class="md-toolbar-row">
                    <div class="md-toolbar-section-start">
                        <md-field>
                            <md-input type="search" class="mb-3" clearable style="width: 200px" placeholder="查找..." v-model="searchQuery">
                            </md-input>
                        </md-field>
                    </div>
                    <div class="md-toolbar-section-end">
                        <md-button slot="title" class="md-success md-sm" style="width: 10px" @click="submit">
                            <md-icon>check_circle</md-icon>
                            确定
                        </md-button>
                        <md-button slot="title" class="md-danger md-sm" style="width: 10px; margin-left: 15px" @click="cancel">
                            <md-icon>highlight_off</md-icon>
                            关闭
                        </md-button>
                    </div>
                </div>
            </md-toolbar>
        </div>
        <div class="md-layout-item md-size-20" v-for="modelResource in modelResourceList" :key="modelResource._id">
            <image-card class="img-card" header-animation="true">
                <img class="img" slot="imageHeader" :src="modelResource.model_image" />
                <template slot="footer">
                    <div class="stats">
                        <a href="#" @click="handleResourceDetail(modelResource)">{{ modelResource.model_name }}</a>
                    </div>
                    <div class="stats">
                        <v-checkbox :value="modelResource._id" v-model="checkList" color="success"></v-checkbox>
                    </div>
                </template>
            </image-card>
        </div>
        <div class="md-layout-item md-size-100">
            <pagination class="pagination-no-border pagination-success" v-model="currentPage" :per-page="perPage" :total="total" style="justify-content: center">
            </pagination>
        </div>
        <DeviceLibDetail :showDetailDialog="showDetailDialog" :selectedResource="selectedResource" @handleDetailCancel="handleDetailCancel" @handleDetailSubmit="handleDetailSubmit" v-if="showDetailDialog" />
        <DeviceLibNew :showNewDialog="showNewDialog" @handleCloseDialog="handleCloseDialog" />
    </div>
    </v-app>
</template>
<script>
import DeviceLibDetail from "../../../Lib/DeviceLib/Action/DeviceLibDetail";
import DeviceLibNew from "../../../Lib/DeviceLib/Action/DeviceLibNew";
import { ImageCard, Pagination } from "@/components";
import { ModelGltf } from "vue-3d-model";
import { majorList, industryList, functionList } from '@/api/user';
import { refreshResourceList } from '@/api/model_resource';

const tableAllData = {}

export default {
    props: {
        checkMod: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.perPage * (this.currentPage - 1)
        },
        total() {
            return this.totalItems
        }
    },
    data() {
        return {
            actionFormData: {},
            showDetailDialog: false,
            showNewDialog: false,
            searchQuery: "",
            majorListData: [],
            industryListData: [],
            searchCategory: {},
            checkList: [],
            currentPage: 1,
            selectedItem: {},
            modelResourceList: [],
            selectedResource: {},
            totalItems: 0,
            perPage: 10
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.refreshResourceList();
        });
    },
    created() {
        this.majorList();
        this.industryList();
        // this.functionList();
        this.refreshResourceList();
        this.checkList = this.checkMod ? this.checkMod.map(item => item._id) : []
    },
    components: {
        ImageCard,
        Pagination,
        ModelGltf,
        DeviceLibDetail,
        DeviceLibNew,
    },
    watch: {
        currentPage(val) {
            this.refreshResourceList();
        },
    },
    methods: {
        handleNewCancel() {},
        clearFilter() {
            this.searchQuery = "";
            this.searchCategory = {};
            this.refreshResourceList();
        },
        categorySelected(type, value) {
            this.searchCategory["category_type"] = type;
            this.searchCategory["category_name"] = value;
            this.refreshResourceList();
        },
        refreshResourceList() {
            // const map = configApi.refreshResourceList({
            //     'model_name': this.searchQuery,
            //     ...this.searchCategory,
            //     'page_no': this.currentPage,
            //     'page_size': this.perPage,
            //     'model_resource_category': "device"
            // });
            // api.$axios(map).then(res => {
            //     this.modelResourceList = res.data.data.items;
            //     tableAllData[this.currentPage] = this.modelResourceList
            //     this.totalItems = res.data.data.total;
            // });

            let tempData1 = {
                model_name: this.searchQuery || '',
                ...this.searchCategory,
                page_no: this.currentPage || '',
                page_size: this.perPage,
                'model_resource_category': "device"
            }
            refreshResourceList(tempData1).then((res) => {
                this.modelResourceList = res.data.items;
                tableAllData[this.currentPage] = this.modelResourceList
                this.totalItems = res.data.total;
            })
        },
        handleResourceDetail(item) {
            this.showDetailDialog = true;
            this.selectedResource = item;
        },
        handleDetailSubmit(item) {
            this.refreshResourceList();
            this.showDetailDialog = false;
        },
        handleResourceNew() {
            this.showNewDialog = true;
        },
        submit() {
            const arr = []
            for (const key in tableAllData) {
                arr.push(tableAllData[key])
            }
            const dataMap = arr.flatMap(pageContent => pageContent).reduce((pre, next) => {
                pre[next._id] = next;
                return pre;
            }, {})

            const checkList = this.checkList.map(_id => dataMap[_id])

            this.$emit("handleSubmit", checkList);
        },
        cancel() {
            this.$emit("handleCancel", {});
        },
        handleDetailCancel() {
            this.showDetailDialog = false;
        },
        handleCloseDialog(res) {
            this.showNewDialog = false;
            if (res) {
                this.refreshResourceList();
                console.log(res);
            }
        },
        handleNewSubmit() {
            this.showNewDialog = false;
        },
        handleSearch(e) {
            console.log(e.target.value);
            this.refreshResourceList();
        },
        majorList(params) {
            majorList().then((res) => {
                if (res.code === '200') {
                    this.majorListData = res.data;
                }
            })
        },
        industryList(params) {
            industryList().then((res) => {
                if (res.code === '200') {
                    this.industryListData = res.data;
                }
            })
        },
    },
};
</script>
<style lang="css" scoped>
.img-card {
    margin-left: 0 !important;
    margin-right: 0 !important;
}

.img {
    width: 200px;
    height: 180px;
    margin: 0 !important;
}

.md-group {
    margin-bottom: 24px;
}

.md-button {
    border-radius: 0;
}

.md-tab {
    max-width: 600px;
    max-height: 400px;
    overflow: auto;
}
</style>